import { render, staticRenderFns } from "./fkjz_yqy.vue?vue&type=template&id=3bc56602&scoped=true&"
import script from "./fkjz_yqy.vue?vue&type=script&lang=js&"
export * from "./fkjz_yqy.vue?vue&type=script&lang=js&"
import style0 from "./fkjz_yqy.vue?vue&type=style&index=0&id=3bc56602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc56602",
  null
  
)

export default component.exports